import { request } from './client.js';

export async function aiNutrition(ingredients, modelName) {
  const data = await request('/api/ai/nutrition', {
    method: 'POST',
    body: JSON.stringify({ ingredients, modelName }),
  });
  return data.nutritionFacts;
}

export async function aiChat(messages, modelName) {
  return await request('/api/ai/chat', {
    method: 'POST',
    body: JSON.stringify({ messages, modelName }),
  });
}

export async function aiGenerate(promptText, modelName) {
  const data = await request('/api/ai/generate', {
    method: 'POST',
    body: JSON.stringify({ promptText, modelName }),
  });
  return data.recipe;
}

export async function aiSearch(query, recipes, modelName) {
  const data = await request('/api/ai/search', {
    method: 'POST',
    body: JSON.stringify({ query, recipes, modelName }),
  });
  return data.matchedIds || [];
}

export async function aiSubstitute(ingredientName, modelName) {
  const data = await request('/api/ai/substitute', {
    method: 'POST',
    body: JSON.stringify({ ingredientName, modelName }),
  });
  return data.substitutes || [];
}

export async function aiVision(base64Image, mimeType = 'image/jpeg', modelName) {
  const data = await request('/api/ai/vision', {
    method: 'POST',
    body: JSON.stringify({ base64Image, mimeType, modelName }),
  });
  return data.items || [];
}

export async function aiCategorize(ingredientsList, modelName) {
  const data = await request('/api/ai/categorize', {
    method: 'POST',
    body: JSON.stringify({ ingredientsList, modelName }),
  });
  return data.categories || {};
}
